function Shop_order(element) {
    this.$element = $(element);
	
	this.selectors = {
	    checkboxShippingAddress: '.js-checkbox-shipping-address',
	    containerShippingAddress: '.js-container-shipping-address',
	    fieldBillingFirstname: '.js-field-billing-firstname',
	    fieldBillingLastname: '.js-field-billing-lastname',
	    fieldBillingAddress: '.js-field-billing-address',
	    fieldBillingZip: '.js-field-billing-zip',
	    fieldBillingCity: '.js-field-billing-city',
	    fieldBillingCountry: '.js-field-billing-country',
	    fieldBillingPhone: '.js-field-billing-phone',
	    fieldBillingMail: '.js-field-billing-mail',
	    fieldShippingFirstname: '.js-field-shipping-firstname',
	    fieldShippingLastname: '.js-field-shipping-lastname',
	    fieldShippingAddress: '.js-field-shipping-address',
	    fieldShippingZip: '.js-field-shipping-zip',
	    fieldShippingCity: '.js-field-shipping-city',
	    fieldShippingCountry: '.js-field-shipping-country',
	    fieldShippingPhone: '.js-field-shipping-phone',
	    fieldShippingMail: '.js-field-shipping-mail'
    };
    
    this.data = {
	    currentPage: 'current-page'	    
    };
    
    this.classNames = {
	    disabled: 'disabled'
    };
    
    this.init = function() {
	    
	    this.currentPage = this.$element.data(this.data.currentPage);

	    switch(this.currentPage) {
		    case 'address': 
		    	this.initAddress();
		    break;
		    case 'summary': 
		    	this.initSummary();
		    break;
	    }
	};
	
	this.initAddress = function() {
		
		this.$checkboxShippingAddress = this.$element.find(this.selectors.checkboxShippingAddress);
		this.$containerShippingAddress = this.$element.find(this.selectors.containerShippingAddress);
		
		/*
		this.$fieldBillingFirstname = this.$element.find(this.selectors.fieldBillingFirstname);
		this.$fieldBillingLastname = this.$element.find(this.selectors.fieldBillingLastname);
		this.$fieldBillingAddress = this.$element.find(this.selectors.fieldBillingAddress);
		this.$fieldBillingZip = this.$element.find(this.selectors.fieldBillingZip);
		this.$fieldBillingCity = this.$element.find(this.selectors.fieldBillingCity);
		this.$fieldBillingCountry = this.$element.find(this.selectors.fieldBillingCountry);
		this.$fieldBillingPhone = this.$element.find(this.selectors.fieldBillingPhone);
		this.$fieldBillingMail = this.$element.find(this.selectors.fieldBillingMail);
		*/
		
		this.$fieldShippingFirstname = this.$element.find(this.selectors.fieldShippingFirstname);
		this.$fieldShippingLastname = this.$element.find(this.selectors.fieldShippingLastname);
		this.$fieldShippingAddress = this.$element.find(this.selectors.fieldShippingAddress);
		this.$fieldShippingZip = this.$element.find(this.selectors.fieldShippingZip);
		this.$fieldShippingCity = this.$element.find(this.selectors.fieldShippingCity);
		this.$fieldShippingCountry = this.$element.find(this.selectors.fieldShippingCountry);
		this.$fieldShippingPhone = this.$element.find(this.selectors.fieldShippingPhone);
		this.$fieldShippingMail = this.$element.find(this.selectors.fieldShippingMail);
				
		this.$checkboxShippingAddress.on('i4:change', this.$onClickCheckboxShippingAddress.bind(this));
		this.updateShippingAddress();
	};
	
	this.initSummary = function() {
		
	};
	
	this.$onClickCheckboxShippingAddress = function() {
		this.updateShippingAddress();
	};
	
	this.updateShippingAddress = function() {
			
		if (this.$checkboxShippingAddress.is(':checked')) {
			this.$fieldShippingFirstname.removeClass(this.classNames.disabled);
			this.$fieldShippingLastname.removeClass(this.classNames.disabled);
			this.$fieldShippingAddress.removeClass(this.classNames.disabled);
			this.$fieldShippingZip.removeClass(this.classNames.disabled);
			this.$fieldShippingCity.removeClass(this.classNames.disabled);
			this.$fieldShippingCountry.removeClass(this.classNames.disabled);
			this.$fieldShippingPhone.removeClass(this.classNames.disabled);
			this.$fieldShippingMail.removeClass(this.classNames.disabled);
				
			this.$containerShippingAddress.show();
			
		} else {
			this.$containerShippingAddress.hide();
			
			this.$fieldShippingFirstname.addClass(this.classNames.disabled);
			this.$fieldShippingLastname.addClass(this.classNames.disabled);
			this.$fieldShippingAddress.addClass(this.classNames.disabled);
			this.$fieldShippingZip.addClass(this.classNames.disabled);
			this.$fieldShippingCity.addClass(this.classNames.disabled);
			this.$fieldShippingCountry.addClass(this.classNames.disabled);
			this.$fieldShippingPhone.addClass(this.classNames.disabled);
			this.$fieldShippingMail.addClass(this.classNames.disabled);
		}
		
	};
}
